// dateCompareSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentDateComparison: null,
};

const dateCompareSlice = createSlice({
  name: 'dateCompare',
  initialState,
  reducers: {
    setCurrentDateComparison: (state, action) => {
      state.currentDateComparison = action.payload;
    },
  },
});

export const { setCurrentDateComparison } = dateCompareSlice.actions;

export default dateCompareSlice.reducer;